import { FreelancerProfile } from "../models/FreelancerProfile";

/**
 * Indicates whether the freelancer's onboarding company information is fully
 * provided (portage or own structure). Returns false when the freelancer ticked
 * the "registration in progress" checkbox or when one of the required fields
 * is missing.
 */
export const isFreelancerCompanyInfoComplete = (
	profile: FreelancerProfile | undefined | null
): boolean => {
	const company = profile?.company;

	if (!company) {
		return false;
	}

	if (company.isRegistrationInProgress) {
		return false;
	}

	return Boolean(
		company.legalName &&
			company.identificationNumber &&
			company.contactFirstName &&
			company.contactLastName &&
			company.contactEmail &&
			company.countryId &&
			company.areCompanyInformationAcknowledged
	);
};
